<script>
export default {
    name: "DaysSelect",
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showZero: {
            type: Boolean,
            default: true
        }
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    watch: {
        value: {
            handler(val) {
                this.selectDay = val ? Number(val) : ''
            },
            immediate: true
        }
    },
    data() {
        return {
            selectDay: '',
        }
    },
    mounted() {
    },
    computed: {
        days() {
            let days = [
                {
                    name: "长期（无期限）",
                    day: -1
                },
                {
                    name: "3年（1095天）",
                    day: 1095
                },
                {
                    name: "1年（365天）",
                    day: 365
                },
                {
                    name: "半年（180天）",
                    day: 180
                },
                {
                    name: "3个月（90天）",
                    day: 90
                },
                {
                    name: "1个月（30天）",
                    day: 30
                },
                {
                    name: "半个月（15天）",
                    day: 15,
                },
                {
                    name: "一星期（7天）",
                    day: 7
                }, {
                    name: "已过期",
                    day: 0
                },
            ]
            
            if (!this.showZero) {
                days.pop()
            }
            
            return days
        }
    },
    methods: {
        selectDayChanged() {
            this.$emit('change', this.selectDay)
        }
    }
}
</script>

<template>
    <a-select v-model="selectDay" class="full-with at-select" :disabled="disabled" @change="selectDayChanged">
        <template v-for="(md,key) in days">
            <a-select-option :value="md.day" :key="key">
                <span>{{ md.name }}</span>
            </a-select-option>
        </template>
    </a-select>
</template>

<style scoped lang="less">

</style>